import { useTranslation } from "react-i18next";

export default function WijkenBereikbaarheid() {
  const { t } = useTranslation("contact");
  const leftTags = t("wijken.leftTags", { returnObjects: true }) as string[];
  const rightTags = t("wijken.rightTags", { returnObjects: true }) as string[];

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("wijken.h2")}
        </h2>

        <div className="flex flex-col md:flex-row gap-8 md:gap-12">
          {/* LEFT: Wijken in Eindhoven */}
          <div className="flex-1">
            <span className="inline-block font-geist-mono text-xs font-bold tracking-wider text-brand-text/60 bg-white border border-brand-border px-3 py-1.5 rounded-full mb-4 md:mb-5">
              {t("wijken.leftLabel")}
            </span>
            <div className="flex flex-wrap gap-2 md:gap-2.5">
              {leftTags.map((tag) => (
                <span
                  key={tag}
                  className="font-geist text-sm px-4 py-2 rounded-full border border-brand-border bg-white text-brand-text hover:border-brand-yellow hover:bg-brand-yellow/10 transition-colors cursor-default whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* RIGHT: Omliggende gemeenten */}
          <div className="flex-1">
            <span className="inline-block font-geist-mono text-xs font-bold tracking-wider text-brand-text/60 bg-white border border-brand-border px-3 py-1.5 rounded-full mb-4 md:mb-5">
              {t("wijken.rightLabel")}
            </span>
            <div className="flex flex-wrap gap-2 md:gap-2.5">
              {rightTags.map((tag) => (
                <span
                  key={tag}
                  className="font-geist text-sm px-4 py-2 rounded-full border border-brand-border bg-white text-brand-text hover:border-brand-yellow hover:bg-brand-yellow/10 transition-colors cursor-default whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}